import { render } from "./OurGoal.vue?vue&type=template&id=8df6735a"
import script from "./OurGoal.vue?vue&type=script&lang=js"
export * from "./OurGoal.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__